import React from 'react';

const Credits = ({ name }) => (
    <div class="login-bg">
        <div class="container">
            <div class="row justify-content-center" style={{ height: "100vh"}}>
                <div class="creditsVisible">
                    <div class="container" style={{ marginTop: "40px"}}>
                        <div class="ant-page-header">
                            <div class="ant-page-header-heading">
                                <span class="ant-page-header-heading-title">
                                    Credits
                                </span>
                                <span class="ant-page-header-heading-sub-title">
                                    La storia di Polar
                                </span>
                            </div>
                            <div class="ant-page-header-content">
                                <div class="ant-row-flex content">
                                    <div class="main" style={{ flex: "1 1 0%"}}>
                                        <div class="content">
                                            <div class="ant-typography">
                                                Polar è una piattaforma digitale preposta all’archiviazione dei dati.
                                                Nato dall’esigenza di creare un database in cui salvare le informazioni principali di
                                                aziende italiane (ragione sociale, settore di mercato di appartenenza, contatti di uffici e
                                                personale, dipartimenti e prodotti), si pone come obiettivo di offrire un servizio che sia
                                                innovativo e il più versatile possibile, al fine di soddisfare le svariate esigenze di
                                                un mondo, quello professionale e non solo, sempre più liquido e improntato al digitale.
                                            </div>
                                            <div class="ant-typography">
                                                Verosimilmente, tanti potrebbero essere gli usi e gli ambienti in cui si potrà utilizzare
                                                questo sistema: per esempio, nella pubblica amministrazione, all’interno dei sistemi bancari,
                                                nel sistema scolastico… insomma, non c’è limite all’implementazione.
                                            </div>
                                            <div class="ant-row-flex contentLink">
                                                <a class="footerLinkIcon" href="/" style={{ marginRight: "16px", display: "flex", alignItems: "center"}}>
                                                    <img src="https://gw.alipayobjects.com/zos/rmsportal/ohOEPSYdDTNnyMbGuyLb.svg" alt="start" style={{ marginRight: "8px" }}/>
                                                        Login
                                                </a>
                                            </div>
                                            </div>
                                        </div>
                                    <div class="extra" style={{marginLeft: "80px"}}>
                                            <img src="https://gw.alipayobjects.com/mdn/mpaas_user/afts/img/A*KsfVQbuLRlYAAAAAAAAAAABjAQAAAQ/original" alt="content"/>
                                    </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
)

export { Credits as default };


// WEBPACK FOOTER //
// ./src/util/Credits.js